module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/name/suffix.js
 ** module id = 700
 ** module chunks = 0
 **/